module.exports = __webpack_public_path__ + "static/media/hoodie-man-back-min.2356673b.png";